import graphql__f05fef457c1fb10e32db from "./__generated__/UserMarkerTooltip_userMarker.graphql.js";
import graphql__173de7074b58b01165be from "./__generated__/UserMarkerTooltipQuery.graphql.js";import { graphql, useFragment } from "react-relay";

import AppQueryRenderer from "../../AppQueryRenderer";
import MapTooltip from "../../Maps/MapTooltip";
import Spinner from "../../Utils/Spinner";
import UserMarkerTooltipContent from "./UserMarkerTooltipContent";

const UserMarkerTooltip = props => {
  const { userId } = useFragment(UserMarkerTooltip_userMarker, props.userMarker);

  return (
    <MapTooltip sticky={true} opacity={1}>
      <AppQueryRenderer
        query={UserMarkerTooltipQuery}
        variables={{ userId }}
        component={UserMarkerTooltipContent}
        loader={<Spinner />}
      />
    </MapTooltip>
  );
};

const UserMarkerTooltip_userMarker = graphql__f05fef457c1fb10e32db;

const UserMarkerTooltipQuery = graphql__173de7074b58b01165be;

export default UserMarkerTooltip;
